'use client'

import { domAnimation, LazyMotion, MotionConfig } from 'motion/react'
import { ReactNode } from 'react'

interface MotionProviderProps {
  children: ReactNode
}

const MotionProvider = ({ children }: MotionProviderProps) => {
  return (
    <LazyMotion features={domAnimation}>
      <MotionConfig
        reducedMotion="user"
        transition={{
          duration: 0.3
        }}
      >
        {children}
      </MotionConfig>
    </LazyMotion>
  )
}

export default MotionProvider
